/**
 * Spinner — indeterminate progress indicator (theme T5c §4.1).
 *
 * 1 rev/sec linear (NOT motion-slow — intentional per T5c note).
 * `currentColor` fill lets callers colour-shift via Tailwind `text-*`.
 */
import { cn } from './cn';

interface SpinnerProps {
  size?: number;
  className?: string;
  'aria-label'?: string;
}

export function Spinner({
  size = 16,
  className,
  'aria-label': ariaLabel = 'Loading',
}: SpinnerProps) {
  return (
    <svg
      aria-label={ariaLabel}
      className={cn('animate-spin', className)}
      fill="none"
      height={size}
      role="status"
      viewBox="0 0 24 24"
      width={size}
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle cx="12" cy="12" r="10" stroke="currentColor" strokeOpacity="0.2" strokeWidth="3" />
      <path
        d="M22 12a10 10 0 0 0-10-10"
        stroke="currentColor"
        strokeLinecap="round"
        strokeWidth="3"
      />
    </svg>
  );
}
